var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.098.39 3.938 7.3l-1.9-2.03c-.35-.33-.9-.35-1.3-.07-.39.29-.5.8-.26 1.21l2.25 3.66c.22.34.6.55 1.03.55.41 0 .8-.21 1.02-.55.36-.47 7.23-8.66 7.23-8.66.9-.92-.19-1.73-.91-1.03v.01Z",
    fill: "currentColor"
  })));
};
export { SvgCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMyAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjA5OC4zOSAzLjkzOCA3LjNsLTEuOS0yLjAzYy0uMzUtLjMzLS45LS4zNS0xLjMtLjA3LS4zOS4yOS0uNS44LS4yNiAxLjIxbDIuMjUgMy42NmMuMjIuMzQuNi41NSAxLjAzLjU1LjQxIDAgLjgtLjIxIDEuMDItLjU1LjM2LS40NyA3LjIzLTguNjYgNy4yMy04LjY2LjktLjkyLS4xOS0xLjczLS45MS0xLjAzdi4wMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";